import { render, staticRenderFns } from "./SearchFilterDefault.vue?vue&type=template&id=1b6f0bea&"
import script from "./SearchFilterDefault.vue?vue&type=script&lang=js&"
export * from "./SearchFilterDefault.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterDefault.vue?vue&type=style&index=0&id=1b6f0bea&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports